import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { MetricTileComponent } from '../../Partials/metric-tile/metric-tile.component';
import { PlanRevenueTableComponent } from '../../Partials/plan-revenue-table/plan-revenue-table.component';
import { DashboardFacade } from '../../../../../Facades/Dashboard/dashboard.facade';
import {
  CURRENCY_UNRESOLVED_HINT,
  REVENUE_PARTIAL_HINT,
  RESTRICTED_METRIC_HINT,
  TREND_UNAVAILABLE_REASON,
  VALUE_UNRESOLVED,
} from '../../../../../Consts/backoffice.const';
import { DASHBOARD_SOURCES } from '../../../../../Consts/dashboard.const';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    DecimalPipe,
    MatIconModule,
    MetricTileComponent,
    PlanRevenueTableComponent,
    TranslatePipe,
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-block' },
})
export class DashboardComponent {
  readonly facade = inject(DashboardFacade);

  readonly sources = DASHBOARD_SOURCES;
  readonly trendReason = TREND_UNAVAILABLE_REASON;
  readonly partialHint = REVENUE_PARTIAL_HINT;
  readonly restrictedHint = RESTRICTED_METRIC_HINT;
  readonly currencyHint = CURRENCY_UNRESOLVED_HINT;
  readonly unresolved = VALUE_UNRESOLVED;

  readonly currencyLabel = computed<string>(() => this.facade.currency() ?? this.unresolved);

  readonly revenueNote = computed<string>(() =>
    this.facade.revenueIsPartial() ? this.partialHint : '',
  );

  readonly currencyNote = computed<string>(() =>
    this.facade.currency() === null ? this.currencyHint : '',
  );

  reload(): void {
    this.facade.reload();
  }
}
